import { useState } from "react";
import { Button } from "primereact/button";

import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils/themeClasses";

import ActionBar from "../ActionBar/ActionBar";

import S from "../_Lesson.module.scss";

const knowledgeOptions = {
  1: {
    emoticon: ":-(",
    label: "None",
  },
  2: {
    emoticon: ":-\\",
    label: "Little",
  },
  3: {
    emoticon: ":-)",
    label: "Some",
  },
  4: {
    emoticon: ":-D",
    label: "A lot",
  },
  5: {
    emoticon: "B-)",
    label: "So much",
  },
};

const Survey = ({ headerText, onSubmit, description, isAfterLessonSurvey, hasNextLesson }) => {
  const [rating, setRating] = useState(null);

  const Actions = [
    {
      ...(isAfterLessonSurvey && hasNextLesson
        ? {
            label: "Next Lesson",
            icon: "chevron-right",
            iconPos: "right",
            onClick: () => onSubmit(rating),
          }
        : {
            label: "Confirm",
            icon: "check",
            onClick: () => onSubmit(rating),
          }),
    },
    {
      label: isAfterLessonSurvey ? "Exit" : "Skip",
      severity: "secondary",
      onClick: () => onSubmit(rating, isAfterLessonSurvey),
    },
  ];

  return (
    <div className={C(T.bgElevation2, "flex flex-col rounded-l-sm w-full")}>
      <div className={C("flex-1", T.largePaddedContainer)}>
        <h2 className="atlas-h1 mb-8 mt-6">{headerText}</h2>
        <div className="flex-1">
          <p className="atlas-h5 mb-4">Rate your knowledge</p>
          <p className="atlas-h4 mb-4">How much do you think you know about this topic?</p>
          <p className="body-md text-muted">{description}</p>
          <div className="mt-10">
            {Object.entries(knowledgeOptions).map(([key, option]) => (
              <Button
                key={key}
                severity={rating === key ? undefined : "secondary"}
                className={S.learningSwingOption}
                onClick={() => setRating(key)}
              >
                <p>{option.emoticon}</p>
                <p>{option.label}</p>
                <p>{key}</p>
              </Button>
            ))}
          </div>
        </div>
      </div>
      <ActionBar actions={Actions} />
    </div>
  );
};

export default Survey;
